import { NetworkId, WalletId, type WalletManagerConfig } from '@txnlab/use-wallet-react';

// Nodely free public API — no API key required
// Docs: https://nodely.io/docs/free/start
const NODELY_MAINNET_ALGOD = 'https://mainnet-api.4160.nodely.dev';
const NODELY_TESTNET_ALGOD = 'https://testnet-api.4160.nodely.dev';

export const walletConfig: WalletManagerConfig = {
    wallets: [
        // ✅ ALL WALLETS IN CONSISTENT ORDER (no platform filtering here)
        // The wallet SDK will handle platform availability internally
        {
            id: WalletId.PERA,
            options: {
                compactMode: false,
                shouldShowSignTxnToast: false,
                chainId: 416001, // Algorand Mainnet WalletConnect chainId — prevents Pera error 4100
            }
        },
        {
            id: WalletId.LUTE,
            options: { siteName: 'Pickle Pong' },
        },
        WalletId.DEFLY,
        WalletId.EXODUS,
        {
            id: WalletId.WEB3AUTH,
            options: {
                clientId: 'BNuBLzk0KK1TGn9Yz-VqQXv_5KF9psZo_IF4aG1XLvNnhuaEcsGuuznbDys-IGZ7-SfxLX-YH3UHpvGdCDM11Lw',
                web3AuthNetwork: 'sapphire_mainnet' as const,
            }
        }
    ],

    // Both networks listed so WalletManager can restore any cached session.
    // setActiveNetwork(MAINNET) in App.tsx then forces Mainnet after init.
    networks: {
        [NetworkId.MAINNET]: {
            algod: {
                baseServer: NODELY_MAINNET_ALGOD,
                port: '',
                token: '',
            },
        },
        [NetworkId.TESTNET]: {
            algod: {
                baseServer: NODELY_TESTNET_ALGOD,
                port: '',
                token: '',
            },
        },
    },

    defaultNetwork: NetworkId.MAINNET,
};
